// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"ff55cec4adff12711b53","655":"8ed5f840a87b5b9fc4ab"}[chunkId] + ".js";
};